"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const firstDayOfTheYear_1 = require("./firstDayOfTheYear");
const getDayNumber_1 = require("./getDayNumber");
const ramda_1 = require("ramda");
const daysInAWeek = 7;
const daysOfTheYearRefMap = {
    0: { name: "Sun", offsetFromMonday: 6 },
    1: { name: "Mon", offsetFromMonday: 0 },
    2: { name: "Tue", offsetFromMonday: 1 },
    3: { name: "Wed", offsetFromMonday: 2 },
    4: { name: "Thu", offsetFromMonday: 3 },
    5: { name: "Fri", offsetFromMonday: 4 },
    6: { name: "Sat", offsetFromMonday: 5 },
};
// Week numbers are indexed from 1 e.g. 1st week of the year is week 1
// This function returns the week number of the year starting from Monday
// So if the first day of the year is a Friday, the first week of the year will include only
// 3 days (Friday, Saturday, Sunday) and the week number will be 1
// The second week will start from the next Monday and end on Sunday
const getWeekNumberFromMonday = (date) => Math.ceil((0, ramda_1.add)(daysOfTheYearRefMap[(0, firstDayOfTheYear_1.default)((0, date_fns_1.getYear)(!!date ? new Date(date) : new Date()))].offsetFromMonday, (0, getDayNumber_1.default)(date)) / daysInAWeek);
exports.default = getWeekNumberFromMonday;
//# sourceMappingURL=getWeekNumberFromMonday.js.map